import { useWorkspace } from '@/features/workspaces/hooks';
import { useCompanyValues } from '@/providers';
import { useGetWorkspaceConnectorsQuery } from '@/services/endpoints/workspace-connectors';
import { CHANNEL_CONNECTOR_NAMES } from './components/modelli/TemplateFlowEditor';
import { ComuniChannel } from './templates/catalog';

/**
 * Per-channel connector availability for the ChannelStep gating.
 * `undefined` = still loading (callers should treat as available to avoid a flash of "not connected").
 */
export const useChannelAvailability = () => {
  const workspace = useWorkspace();
  const { currentLanguage } = useCompanyValues();
  const { data, isLoading, isError } = useGetWorkspaceConnectorsQuery(
    { workspaceId: workspace.id, lang: currentLanguage },
    { skip: !workspace.id }
  );

  const availabilityFor = (channel: ComuniChannel): boolean | undefined => {
    if (isError) return false;
    if (isLoading || !data) return undefined;
    return data.some((item) => CHANNEL_CONNECTOR_NAMES[channel].includes(item.name) && item.isAuthenticated);
  };

  return {
    availability: {
      whatsapp: availabilityFor('whatsapp'),
      sms: availabilityFor('sms'),
      email: availabilityFor('email'),
    },
    isLoading,
  };
};
